import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
} from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiDeleteButton from "src/components/core-components/mui/buttons/ByzMuiDeleteButton";
import ByzDeleteConfirmDialog from "src/components/core-components/mui/ByzDeleteConfirmDialog";
import { useTranslate } from "src/locales";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzSelectListPopupInput from "src/components/core-components/mui/inputs/ByzSelectListPopupInput";

type DeleteState = {
  open: boolean;
  rowId: string;
  url: string;
};

const Components: React.FC = () => {
  const [deleteState, setDeleteState] = useState<DeleteState>({
    open: false,
    rowId: "",
    url: "",
  });

  const { t } = useTranslate();

  const handleDeleteRow = (id: number, type: string) => {
    setDeleteState({ open: true, rowId: id.toString(), url: type });
  };

  return (
    <Card sx={{ mb: 3 }}>
      <ByzMuiTypography variant="h3" sx={{ borderBottom: "1px solid #E0E0E0" }}>
        Diğer Componentler
      </ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "100%" }}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <ByzMuiDeleteButton onClick={() => handleDeleteRow(1, "")} />

                <ByzDeleteConfirmDialog
                  open={deleteState.open}
                  onClose={() =>
                    setDeleteState({ ...deleteState, open: false })
                  }
                  patientId={deleteState.rowId}
                  url={deleteState.url}
                  onSuccess={() => console.log("success")}
                  title={t("definition-delete")}
                  content={t("definition-delete-content")}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiDeleteButton ve ByzDeleteConfirmDialog Kullanılır, title
                  ve content belirtilmeli belirtilmezse default olarak
                  <b>"title"</b>:"Silmek İstediğinize Emin misiniz?",
                  <b>"content"</b>: "Silme işlemi için açıklama girmelisiniz!"
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiOpenProcessMenu
                  menuItems={[
                    {
                      label: t("buttons.approve-all"),
                      iconColor: "success",
                      onClick: () => console.log("approve-all"),
                    },
                    {
                      label: t("buttons.reject-all"),
                      iconColor: "error",
                      onClick: () => console.log("reject-all"),
                    },
                  ]}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiOpenProcessMenu , menuitems alan bir nesne , label ve
                  iconcolor parametreleri alıyor.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <ByzMuiRadioButton
                  typographyText="exists,not-exists"
                  layout="row"
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzMuiRadioButton, typographyText (virgülle ayrılır ve .json
                  daki cümle tanımalamaları kullanılmalıdır) ve layout (row veya
                  column) parametrelerini alır.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <ByzSelectListPopupInput
                  url="/nurse/v1/Nurse/GetNurseFloorPrivList/V1"
                  method="POST"
                  postData={{
                    useR_ID: 1,
                    hB_ID: 0,
                  }}
                  dialogTitle={t("adverse-effect-form.drug-list")}
                  displayField="NAME"
                  dialogShowOkButton={true}
                />
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzSelectListPopupInput, ByzList ile aynıdır.
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default Components;
